export default "__VITE_PUBLIC_ASSET__082eb16f__"